import { ROLES } from './../modulos/componentes-compartidos/menu/items';
import { AutenticacionService } from 'src/app/servicios/autenticacion.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolGuard  {

  constructor(
    private autenticacionService: AutenticacionService,
    private router: Router
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      let roles: Array<string> = route.data.roles;
      const rolUsuario = this.autenticacionService.dataLogin.role;

      if(!roles.includes(rolUsuario)) {
        this.router.navigate(["/"]);
      }

      if(route.url.length === 0 && rolUsuario === ROLES.CELADOR) {
        this.router.navigate(["/visitantes"]);
      }

      return roles.includes(rolUsuario);
  }
  
}
